export default "__VITE_ASSET__DpTQOToN__"